/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Admin_OnlyInputs */



/**
* | output |
* | --- |
* | "Only team admins can change these settings." |
*
* @param {Options_Watermark_Admin_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_admin_only = /** @type {((inputs?: Options_Watermark_Admin_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Admin_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuls les administrateurs d'équipe peuvent modifier ces paramètres.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Team-Administratoren können diese Einstellungen ändern.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo gli amministratori del team possono modificare queste impostazioni.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменять эти настройки могут только администраторы команды.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo los administradores del equipo pueden cambiar estos ajustes.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("只有团队管理员可以更改这些设置。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("これらの設定を変更できるのはチーム管理者のみです。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केवल टीम एडमिन ही ये सेटिंग्स बदल सकते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Apenas os administradores da equipa podem alterar estas definições.")
	return /** @type {LocalizedString} */ ("Only team admins can change these settings.")
});